import { Pages } from '../../../common/src/pages.ts';
import { localStorageGet, LocalStorageKey, localStorageRemove, localStorageSet } from '../data/client_local_storage.ts';

import type { SongList } from '../../../common/src/model.ts';

export function clearProspectiveSubscriptionOrigin() {
  localStorageRemove(LocalStorageKey.ProspectiveSubscriptionOriginPage);
  localStorageRemove(LocalStorageKey.ProspectiveSubscriptionPlaylist);
  localStorageRemove(LocalStorageKey.ProspectiveSubscriptionPlaylistIndex);
}

export function storeProspectiveSubscriptionOrigin({
  originPage,
  playlist,
  playlistIndex,
}: {
  originPage?: Pages;
  playlist?: SongList;
  playlistIndex?: number;
}) {
  clearProspectiveSubscriptionOrigin();
  if (originPage) {
    localStorageSet(LocalStorageKey.ProspectiveSubscriptionOriginPage, originPage);
  }
  if (playlist) {
    localStorageSet(LocalStorageKey.ProspectiveSubscriptionPlaylist, playlist);
    localStorageSet(LocalStorageKey.ProspectiveSubscriptionPlaylistIndex, playlistIndex ?? 0);
  }
}

export function consumeSubscriptionReturnOrigin(): Pages {
  const originPage = localStorageGet(LocalStorageKey.ProspectiveSubscriptionOriginPage);
  const playlist = localStorageGet(LocalStorageKey.ProspectiveSubscriptionPlaylist);
  const playlistIndex = localStorageGet(LocalStorageKey.ProspectiveSubscriptionPlaylistIndex);
  clearProspectiveSubscriptionOrigin();
  if (playlist) {
    localStorageSet(LocalStorageKey.Playlist, playlist);
    localStorageSet(LocalStorageKey.PlaylistIndex, playlistIndex);
    localStorageSet(LocalStorageKey.IsPlayerMaximized, true);
  }
  // no origin page stored: land where every onboarding sequence ends (GitHub issue #3551)
  return originPage ?? Pages.Organization;
}
